/**
 * Parse "City, State, Zip" into { city, state } for U.S. addresses.
 * - Accepts ZIP as 12345 or 12345-6789
 * - Accepts mixed case for city/state; returns normalized city + uppercase state
 * - Returns null if the input doesn't match the expected format
 */
export function parseCityState(input: string): { city: string; state: string } | null {
  const pattern = /^(.+?),\s*([A-Z]{2})\s*,\s*\d{5}(?:-\d{4})?$/i;

  const match = input.trim().match(pattern);
  if (!match) return null;

  const rawCity = match[1].trim();
  const state = match[2].toUpperCase();

  const city = rawCity
    .toLowerCase()
    .split(/([ -])/g)
    .map(part => (/[ -]/.test(part) ? part : part.charAt(0).toUpperCase() + part.slice(1)))
    .join('');

  return { city, state };
}
